import getLocaleData from '../internal/getLocaleData';
export default function mergeOptions(config, defaults, reports, userOptions, overrideOptions) {
    const mergedOptions = Object.assign({}, defaults, userOptions, overrideOptions);
    const resultingLocale = getLocaleData(mergedOptions.locale, config, reports).locale;
    return Object.assign(mergedOptions, {
        locale: resultingLocale
    });
}

//# sourceMappingURL=mergeOptions.js.map